// extracted by mini-css-extract-plugin
module.exports = {"MuiPaper-elevation0":"organizationDetail_MuiPaper-elevation0__2vc33","routes":"organizationDetail_routes__18Blg"};